import { useEffect, useState } from 'react';

import { DesignThinkingToolStage } from '../types';
import { fetchDesignThinkingTools } from '../services/designThinkingService';

export const useDesignThinkingTools = () => {
  const [designThinkingTools, setDesignThinkingTools] = useState<DesignThinkingToolStage[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let isMounted = true;

    const loadDesignThinkingTools = async () => {
      try {
        setLoading(true);
        const data = await fetchDesignThinkingTools();
        if (isMounted) {
          setDesignThinkingTools(data);
          setError(null);
        }
      } catch (error) {
        console.error('Failed to load design thinking tools', error);
        if (isMounted) {
          setError(error instanceof Error ? error.message : 'Unknown error occurred');
        }
      } finally {
        if (isMounted) {
          setLoading(false);
        }
      }
    };

    loadDesignThinkingTools();

    return () => {
      isMounted = false;
    };
  }, []);

  return { designThinkingTools, loading, error };
};
